import { AppThunk } from '../../type'
import { error, finish, loading, set, bulk } from './slice'
import { setLoading } from '../common/slice'
import {
  getLedByGPOListRequestAsync,
  AdminSplitFeesListRequestArgs
} from '../../../features/Financials/AdminSplitFees/api'

export const getLedByGPOListActionAsync =
  (args: AdminSplitFeesListRequestArgs): AppThunk =>
  async (dispatch) => {
    try {
      if (!args.offset) dispatch(setLoading(true))
      dispatch(loading())

      const { data } = await getLedByGPOListRequestAsync(args)

      if (data) {
        if (args?.offset && Number(args.offset) !== 0) {
          dispatch(bulk(data.results))
          return
        }

        dispatch(
          set({
            ...data,
            search: args.search || null
          })
        )
      }

      await Promise.resolve()
    } catch (err) {
      dispatch(
        error({ error: err instanceof Error ? err.message : String(err) })
      )
      await Promise.reject(err)
    } finally {
      dispatch(finish())
      dispatch(setLoading(false))
    }
  }
